/* APS – Feefo range reviews.
   For products grouped in Feefo (product field custom.review_parent), asks Feefo for the whole
   range by parent code only, over all time, and draws the stars and the review list.
   Elements: [data-aps-fparent] = stars; add data-aps-freviews for the full review list. */
(function () {
  if (window.__apsFeefo) return;
  window.__apsFeefo = true;

  var MERCHANT = 'all-pet-solutions';
  var API = 'https://api.feefo.com/api/10/reviews/';
  var PAGE_SIZE = 10;
  var cache = {};

  var css = [
    '.aps-fstars{display:inline-flex;align-items:center;gap:6px;min-height:20px;text-decoration:none;color:inherit}',
    '.aps-fs-icons{display:inline-flex;gap:2px;font-size:18px;line-height:1}',
    '.aps-fs{position:relative;display:inline-block;width:1em;color:#d8d2c8}',
    '.aps-fs::before{content:"\\2605"}',
    '.aps-fs>span{position:absolute;left:0;top:0;height:100%;overflow:hidden;color:#f5b400}',
    '.aps-fs>span::before{content:"\\2605"}',
    '.aps-fs-count{font-size:14px;font-weight:600}',
    '.aps-card__stars .aps-fs-icons{font-size:16px}',
    '.aps-freviews{max-width:1000px;margin:0 auto;padding:8px 0 24px}',
    '.aps-freviews__title{font-size:24px;margin:0 0 16px}',
    '.aps-freviews__head{display:flex;flex-wrap:wrap;gap:24px 48px;align-items:center;padding:20px;border:1px solid #e8e2d9;border-radius:12px;margin-bottom:12px}',
    '.aps-freviews__avg{font-size:40px;font-weight:700;line-height:1}',
    '.aps-freviews__score .aps-fs-icons{font-size:22px;margin:6px 0}',
    '.aps-freviews__based{font-size:14px;opacity:.75}',
    '.aps-freviews__bars{flex:1;min-width:220px;display:grid;gap:6px;font-size:13px}',
    '.aps-fbar{display:grid;grid-template-columns:48px 1fr 32px;gap:10px;align-items:center}',
    '.aps-fbar__track{height:8px;background:#eee8df;border-radius:4px;overflow:hidden}',
    '.aps-fbar__track>span{display:block;height:100%;background:#f5b400}',
    '.aps-fr{padding:16px 0;border-bottom:1px solid #eee8df}',
    '.aps-fr__top{display:flex;justify-content:space-between;align-items:center;gap:12px}',
    '.aps-fr__date{font-size:13px;opacity:.65}',
    '.aps-fr__text{margin:8px 0;line-height:1.5}',
    '.aps-fr__meta{font-size:13px;margin-top:6px}',
    '.aps-fr__prod{font-size:12px;opacity:.65;margin-top:2px}',
    '.aps-freviews__more{margin:20px auto 0;display:block;padding:12px 28px;border-radius:999px;border:1px solid #17706a;background:#fff;color:#17706a;font-weight:600;cursor:pointer}',
    '.aps-freviews__more[hidden]{display:none}',
    '.aps-freviews__by{font-size:12px;opacity:.7;text-align:center;margin-top:16px}',
    '.aps-freviews__by a{color:inherit}'
  ].join('');
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function query(p) {
    return 'merchant_identifier=' + MERCHANT + '&parent_product_sku=' + encodeURIComponent(p) + '&since_period=ALL';
  }
  function getJSON(url) {
    return fetch(url).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function summary(p) {
    if (!cache[p]) cache[p] = getJSON(API + 'summary/product?' + query(p));
    return cache[p];
  }
  function info(d) {
    var r = (d && d.rating) || {};
    var pr = r.product || {};
    return {
      avg: Number(r.rating) || 0,
      count: pr.count || (d && d.meta && d.meta.count) || 0,
      dist: pr,
      url: d && d.product && d.product.reviews_url
    };
  }
  function icons(v) {
    var h = '<span class="aps-fs-icons" role="img" aria-label="Rated ' + v.toFixed(1) + ' out of 5">';
    for (var i = 0; i < 5; i++) {
      var f = Math.max(0, Math.min(1, v - i));
      h += '<span class="aps-fs"><span style="width:' + Math.round(f * 100) + '%"></span></span>';
    }
    return h + '</span>';
  }
  function fmtDate(v) {
    if (!v) return '';
    var d = new Date(v);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  }

  function renderStars(el) {
    summary(el.getAttribute('data-aps-fparent')).then(function (d) {
      var s = info(d);
      if (!s.count) { el.style.display = 'none'; return; }
      el.innerHTML = icons(s.avg) + '<span class="aps-fs-count">(' + s.count + ')</span>';
    }).catch(function () { el.style.display = 'none'; });
  }

  function reviewHTML(rv) {
    var pr = (rv.products && rv.products[0]) || {};
    var rating = Number(pr.rating && pr.rating.rating) || 0;
    var cust = rv.customer || {};
    var name = cust.display_name || 'Verified buyer';
    var loc = cust.display_location;
    var prod = pr.product && pr.product.title;
    var text = pr.review || '';
    var date = fmtDate(pr.created_at || rv.last_updated_date);
    return '<article class="aps-fr">' +
      '<div class="aps-fr__top">' + icons(rating) + (date ? '<span class="aps-fr__date">' + esc(date) + '</span>' : '') + '</div>' +
      (text ? '<p class="aps-fr__text">' + esc(text) + '</p>' : '') +
      '<div class="aps-fr__meta"><strong>' + esc(name) + '</strong>' + (loc ? ', ' + esc(loc) : '') + ' &middot; Verified buyer</div>' +
      (prod ? '<div class="aps-fr__prod">Reviewed: ' + esc(prod) + '</div>' : '') +
      '</article>';
  }

  function renderReviews(el) {
    var p = el.getAttribute('data-aps-fparent');
    summary(p).then(function (d) {
      var s = info(d);
      if (!s.count) { el.style.display = 'none'; return; }
      var bars = '';
      for (var i = 5; i >= 1; i--) {
        var n = s.dist[i + '_star'] || 0;
        var w = Math.round((n / s.count) * 100);
        bars += '<div class="aps-fbar"><span>' + i + ' star</span><span class="aps-fbar__track"><span style="width:' + w + '%"></span></span><span>' + n + '</span></div>';
      }
      el.innerHTML = '<h2 class="aps-freviews__title">Customer reviews</h2>' +
        '<div class="aps-freviews__head"><div class="aps-freviews__score"><div class="aps-freviews__avg">' + s.avg.toFixed(1) + '</div>' + icons(s.avg) +
        '<div class="aps-freviews__based">Based on ' + s.count + ' reviews across the range</div></div>' +
        '<div class="aps-freviews__bars">' + bars + '</div></div>' +
        '<div class="aps-freviews__list" data-list></div>' +
        '<button type="button" class="aps-freviews__more" data-more hidden>Show more reviews</button>' +
        '<p class="aps-freviews__by">Independent reviews collected by Feefo' +
        (s.url ? ' &middot; <a href="' + esc(s.url) + '" target="_blank" rel="noopener">See all on Feefo</a>' : '') + '</p>';
      var list = el.querySelector('[data-list]');
      var more = el.querySelector('[data-more]');
      var page = 0;
      function load() {
        more.disabled = true;
        page++;
        getJSON(API + 'product?' + query(p) + '&page_size=' + PAGE_SIZE + '&page=' + page).then(function (j) {
          var pages = (j.summary && j.summary.meta && j.summary.meta.pages) || page;
          (j.reviews || []).forEach(function (rv) { list.insertAdjacentHTML('beforeend', reviewHTML(rv)); });
          more.hidden = page >= pages;
          more.disabled = false;
        }).catch(function () { more.hidden = true; });
      }
      more.addEventListener('click', load);
      load();
    }).catch(function () { el.style.display = 'none'; });
  }

  function scan() {
    var els = document.querySelectorAll('[data-aps-fparent]:not([data-aps-done])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.setAttribute('data-aps-done', '1');
      if (el.hasAttribute('data-aps-freviews')) renderReviews(el); else renderStars(el);
    }
  }
  scan();
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
